<template>
  <div class="panicBuying-list">
    <div class="panicBuying-list-img">
      <img :src="info ? info.promotionInfoUrl : ''"
           alt="秒杀活动详细图"
           class="car-img">
    </div>
    <div class="panicBuying-content">
      <div class="time">
        <div class="time-content">
          <count-down @start_callback="activeStartHandle()"
                      @end_callback="activeEndHandle()"
                      :currentTime="new Date().getTime()"
                      :startTime="new Date(info ? info.promotionStartTime : '').getTime()"
                      :endTime="new Date(info ? info.promotionEndTime : '').getTime()"
                      tipText="距活动开始"
                      tipTextEnd="距活动结束"
                      endText="活动已结束"
                      dayTxt="天"
                      secondsTxt=""></count-down>
        </div>
      </div>
      <div class="good-list"
           v-for="group in commodityTeamList"
           :key="group.promotionId">
        <div class="good-list-title">{{group.teamName}}</div>
        <el-row :gutter="10">
          <el-col :span="6"
                  v-for="(item, index) in group.commodityPromotionInfoVos"
                  :key="index"
                  class="goods-show-info">
            <div class="good-info">
              <div class="panicBuying-item-good-img"
                   @click="goodDetail(item)">
                <img :src="item.fileUrl || 'static/img/bitmap.png'"
                     alt=""
                     class="good-img"
                     width="270px"
                     height="210px">
              </div>
              <div class="good-name ellipsis"
                   :title="item.title">{{item.title}}</div>
              <div class="good-model-row">
                <div class="good-model ellipsis">
                  型号：&nbsp;{{item.model}}
                  <!-- {{item.modelList | getModel}} -->
                </div>
                <div class="good-number">{{promoitionStatus === 1 ? '限售':'仅剩'}}{{item | getCount}}件</div>
              </div>
            </div>
            <div class="good-price">
              <div class="good-sell-price ellipsis">
                <!-- 原价： -->
                &nbsp;{{item.sellingPrice | formatePrice}}
              </div>
              <div></div>
              <div class="activity-price ellipsis">
                <div class="activity-price-left">
                  ￥<font class="activity-price-font">{{item.price | formatePrice}}</font>
                </div>
                <div class="activity-price-right">
                  <div class="activity-button soon"
                       v-if="promoitionStatus === 1">即将开始</div>
                  <div class="activity-button buying"
                       v-else-if="promoitionStatus === 2 &&(((item.availableInventory || 0) - (item.saleInventory || 0)) > 0)"
                       @click="goodDetail(item)">去抢购</div>
                  <div class="activity-button soon"
                       v-else-if="promoitionStatus === 2">已抢光</div>
                  <div class="activity-button soon"
                       v-else>活动结束</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="good-tip"
           v-if="info">
        <el-row>
          <el-col :span="2">活动主题：</el-col>
          <el-col :span="20">{{info.promotionName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">活动时间：</el-col>
          <el-col :span="20">{{info.promotionTime}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">活动细节：</el-col>
          <el-col :span="20">
            <div v-html="info.promotionContent"
                 class="promotionContent"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { openOther } from '@/utils'
import { getAccessToken } from '@/utils/userInfo'
import CountDown from '@/components/count-down'
import { purchaseInfoBuringPoint } from '@/utils/buryingPoint'
export default {
  name: 'seckillDetail', // 秒杀活动详情页
  data () {
    return {
      loading: false,
      promoitionStatus: 0, // 活动状态 =1 未开始 =2 已开始 =3已结束
      promotionInfoUrl: '',
      commodityTeamList: [],
      info: null
    }
  },
  components: {
    CountDown
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  filters: {
    // getModel (arr) {
    //   let result = ''
    //   if (arr && arr.length) {
    //     let index = arr.findIndex(item => {
    //       return item.name === '型号'
    //     })
    //     if (index > -1) {
    //       result = arr[index].value
    //     }
    //   }
    //   return result
    // },
    getCount (item) {
      let availableInventory = Number(item.availableInventory) || 0
      let saleInventory = Number(item.saleInventory) || 0
      let result = availableInventory - saleInventory
      return result > 0 ? result : 0
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.info = null
      if (this.loading) {
        return false
      }
      this.loading = true
      // detail = 1 只查活动主题内容， detail = 2 查找主题以及抢购商品列表信息(即返回结果中promotionInfoVos=null)
      this.$request.get(`/front/order/payCommodityPromotion/queryPromotionByIdFront/${this.id}`)
        .then(data => {
          purchaseInfoBuringPoint(this.id, '2')
          this.info = data
          let commodityTeamList = []
          commodityTeamList = data.commodityTeamVos || []
          if (data) {
            this.promoitionStatus = data.promoitionStatus
          } else {
            this.promoitionStatus = 0
          }
          this.commodityTeamList = commodityTeamList
        })
        .catch(() => {
          this.promoitionStatus = 0
          this.promotionInfoUrl = ''
          this.commodityTeamList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 活动开始
    activeStartHandle () {
      this.promoitionStatus = 2
    },
    // 活动结束
    activeEndHandle () {
      this.promoitionStatus = 3
    },
    // 立即抢购
    buyNow (good) {
      if (getAccessToken()) {
        if (localStorage.getItem('customerName') && localStorage.getItem('customerName') !== '' && localStorage.getItem('payType') && localStorage.getItem('payType') !== '') {
          this.$router.push({
            name: 'addOrder',
            query: { goodsNum: 1, goodsId: good.id, orderSource: '30' }
          })
        } else {
          this.$message.error('您还没有绑定公司或者您归属公司的支付类型尚未设定,请联系贵公司的管理员')
        }
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    goodDetail (good) {
      if (good) {
        openOther(`goodDetail?spuId=${good.spuId}&skuId=${good.skuId || ''}`)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.panicBuying-list {
  width: 100%;
  .panicBuying-list-img {
    width: 1190px;
    margin: 0 auto;
    height: 384px;
  }
  .car-img {
    width: 1190px;
    height: 384px;
  }
  .panicBuying-content {
    width: 1190px;
    margin: 20px auto;
    .time {
      position: relative;
      margin-left: 18px;
      width: 402px;
      height: 70px;
      padding: 10px;
      // border:1px solid #ccc;
      // border-radius:4px;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0.29px;
      transform: skewX(-30deg);
      background: #e02a21;
      .time-content {
        transform: skewX(30deg);
        line-height: 50px;
        margin-left: 15px;
        /deep/.time-bg {
          text-align: center;
          background: #fff;
          color: #e02a21;
          padding: 5px;
          margin: 5px;
        }
      }
      .font-time {
        font-size: 22px;
        .time-bg {
          text-align: center;
          background: #ffffff;
          color: #e02a21;
          padding: 5px;
          margin: 5px;
        }
      }
    }
    .good-list {
      .good-list-title {
        margin-top: 10px;
        font-size: 26px;
        color: #262626;
        line-height: 37px;
      }
      .goods-show-info {
        // width: 290px;
        // margin-right: 10px;
        margin-top: 10px;
        // height: 325px;
        .good-info {
          background: #fff;
          padding: 12px 12px 5px;
          line-height: 25px;
          .good-img {
            cursor: pointer;
            // width: 100%;
          }
          .panicBuying-item-good-img {
            width: 100%;
            height: 210px;
            cursor: pointer;
          }
          .good-name {
            font-size: 14px;
            color: #262626;
          }
          .good-model-row {
            display: flex;
            justify-content: space-between;
            .good-model {
              flex-grow: 1;
              font-size: 14px;
              color: #999999;
            }
            .good-number {
              text-align: right;
              flex-shrink: 0;
              // width: 60px;
              font-size: 14px;
              color: #e02a21;
            }
          }
        }
        .good-price {
          margin-top: 3px;
          background: #fff;
          padding: 12px 12px 5px;
          line-height: 25px;
          .good-sell-price {
            font-size: 14px;
            color: #999999;
          }
          .activity-price {
            color: #e33135;
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            .activity-price-left {
              flex-grow: 1;
              .activity-price-font {
                font-size: 26px;
              }
            }
            .activity-price-right {
              width: 80px;
              flex-shrink: 0;
              .activity-button {
                height: 30px;
                line-height: 30px;
                color: #ffffff;
                text-align: center;
              }
              .soon {
                background: #aaaaaa;
                cursor: not-allowed;
              }
              .buying {
                background: #e33135;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .good-tip {
      margin-top: 10px;
      background: #fff;
      padding: 20px;
      line-height: 30px;
      .promotionContent {
        /deep/ p {
          margin: 0;
        }
      }
    }
  }
}
</style>
